import type {SpanAttribute, SpanEntry} from './copilot-chat-types'

export interface SpanNode {
  name: string
  spanId: string
  attributes: SpanAttribute[] | null
  startTime: number
  endTime: number
  children: SpanNode[]
  sessionId?: string
  userId?: string
  input?: unknown
  output?: unknown
  metadata?: unknown
}

/**
 * Converts a JSON encoded SpanEntry array into a tree of SpanNodes.
 */
export function processTraceData(entries: SpanEntry[]): SpanNode[] {
  const spanNodeMap = new Map<string, SpanNode>()
  const roots: SpanNode[] = []

  const spanEntryToSpanNode = (entry: SpanEntry): SpanNode => {
    const node: SpanNode = {
      name: entry.name,
      spanId: entry.spanId,
      attributes: entry.attributes,
      startTime: entry.startTime,
      endTime: entry.endTime,
      children: [],
      sessionId: entry.sessionId,
      userId: entry.userId,
      input: entry.input,
      output: entry.output,
      metadata: entry.metadata,
    }

    spanNodeMap.set(node.spanId, node)

    const parentNode = entry.parentId && spanNodeMap.get(entry.parentId)
    if (parentNode) {
      parentNode.children.push(node)
    } else {
      roots.push(node)
    }
    return node
  }

  // rely on side effects to set roots
  entries.map(spanEntryToSpanNode)

  // return nodes without parent references so we don't have circular references
  return roots
}
